import React from 'react';
import Login from '../login/Login';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import RecoverPassword from '../login/RecoverPassword';
import FindCard from '../findCard/FindCard';
import FindBulk from '../findBulk/FindBulk';
import DeckBuilder from '../deckBuilder/DeckBuilder';
import Wishlist from '../wishlist/Wishlist';
import Collection from '../collection/Collection';
import Profile from '../profile/Profile';
import ShoppingCart from '../../components/shoppingCart/ShoppingCart';
import Stats from '../stats/Stats';
import Settings from '../settings/Settings';
import Donations from '../donations/Donations';
const config = require('../../config/config');

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/recover_password" element={<RecoverPassword />} />

        {/* PrivateRoute now handles layout, side menu, and footer */}
        <Route element={<PrivateRoute />}>
          <Route path="/profile" element={<Profile />} />
          <Route path="/findcard" element={<FindCard />} />
          <Route path="/findbulk" element={<FindBulk />} />
          <Route path="/deckbuilder" element={<DeckBuilder />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/shoppingcart" element={<ShoppingCart />} />
          <Route path="/stats" element={<Stats />} />
          {/* Admin-only. The side menu hides the link for everyone else and the
              server rejects non-admins, so this is not a second gate. */}
          <Route path="/settings" element={<Settings />} />
          {config.showDonations && (
            <Route path="/donations" element={<Donations />} />
          )}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
